import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import * as Constants from '../constants';
import 'rxjs/add/operator/map';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

/**
 * ApisService Realiza las solicitudes tipo Request.
 * @author Santiago V. <snippetdeveloper@gmail.com>
 * @copyright (c) 2019 Snippet Developer.
 */

@Injectable({
  providedIn: 'root'
})

export class ApisService {
  data: any;
  constructor(public http: Http, public snackbar: SnackbarComponent) {}

  auth(form) {
    try {
      const user = {
        email: form.value.email,
        password: form.value.password
      };
      const url = Constants.URL_BASE + 'api/auth';
      return new Promise(resolve => {
          this.http.post(url, user).subscribe(data => {
            return resolve(data.json());
        }, err => {
          console.log('!!!!ERROR IN THE LOGIN');
          return resolve(err);
        });
      });
    } catch (e) {
      console.log('!!!!ERROR IN THE LOGIN');
      console.log(e);
    }
  }

  removeUser(id) {
    const user = {
      idUser: id
    };

    try {
      const url = Constants.URL_BASE + 'removeUser';
      return new Promise(resolve => {
        this.http.post(url, user).subscribe(result => {
          return resolve(result.json());
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.log('!!!!ERROR IN REMOVE USER');
      console.log(e);
    }
  }

  getList() {
    try {
      const url = Constants.URL_BASE + 'api/lists';
      return new Promise(resolve => {
        this.http.post(url, '').subscribe(result => {
          return resolve(result.json());
        }, err => {
          return resolve(err);
        });
      });
    } catch (e) {
      console.log('!!!!ERROR IN GET COMPANYS');
      console.log(e);
    }
  }

  getCompanyById(id) {
    const data = {
      id: id
    };

    try {
      const url = Constants.URL_BASE + 'api/userDetail';
      return new Promise(resolve => {
        this.http.post(url, data).subscribe(result => {
          return resolve(result.json());
        }, err => {
          return resolve(err);
        });
      });
    } catch (e) {
      console.log('!!!!ERROR IN THE GET USERS');
      console.log(e);
    }
  }

  removeCompany(id) {
    const user = {
      idCompany: id
    };

    try {
      const url = Constants.URL_BASE + 'removeCompany';
      return new Promise(resolve => {
        this.http.post(url, user).subscribe(result => {
          return resolve(result.json());
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.log('!!!!ERROR IN REMOVE DOCUMENT');
      console.log(e);
    }
  }

  saveCompany(form) {
    const data = {
      nombre: form.name,
      telefono: form.cellphone,
      direccion: form.adress,
      active :  form.state
    };

    try {
      const url = Constants.URL_BASE + 'saveCompany';
      return new Promise(resolve => {
        this.http.post(url, data).subscribe(result => {
          return resolve(result.json());
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.log('!!!!ERROR IN THE GET USERS');
      console.log(e);
    }
  }

}
